import { useNavigate } from 'react-router';

import Button from '@/components/Button/Button';
import EmptyMessage from '@/components/EmptyMessage';
import { darkBlue } from '@/theme/colors';

interface PendingTeamApprovalPromoProps {
  teamName: string;
}

export default function PendingTeamApprovalPromo({
  teamName,
}: PendingTeamApprovalPromoProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <div>
      <EmptyMessage
        style={{ maxWidth: 750, padding: 0 }}
        border={false}
        iconName="search"
        iconColor={darkBlue}
        title="Request sent — waiting on approval"
        body={
          <>
            We sent your request to <strong>{teamName}</strong>. A team owner needs to approve you
            before you can access the workspace.
          </>
        }
        action={
          <Button size="normal" onClick={() => navigate('/dashboard')}>
            Go to your dashboard
          </Button>
        }
      />
    </div>
  );
}
